import { isEmpty, ValidationPredicate } from '@typescript-kit/core';

export const passwordRequirementValidationPredicate: ValidationPredicate = (value: string): boolean => {

  if (isEmpty(value)) {
    return false;
  }
  return value.length >= 6;
};
